<template>
  <v-dialog :value="value" width="400px" persistent>
    <v-card>
      <v-card-title class="headline">Delete Email</v-card-title>
      <v-card-text class="black--text">
        <p>Are you sure you want to delete this email from the queue?</p>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text depressed small @click="close">Cancel</v-btn>
        <v-btn color="error" text depressed small @click="confirmDelete">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, required: true },
    onConfirm: { type: Function, required: true },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    confirmDelete() {
      this.$emit("input", false);
      this.onConfirm();
    },
  },
};
</script>
